import { createSelector } from 'reselect';

import { TITLE_ID_REF, COVER_ID_REF } from '../../data/constants';

const getBookInfo = ({ eReader }) => eReader.bookInfo;

export const getBookAttempts = createSelector([getBookInfo], ({ attempts }) => attempts);

export const getCurrentChapterName = createSelector([getBookInfo], ({ chapters, currentChapterId }) => {
  if (!chapters?.length || !currentChapterId) {
    return undefined;
  }

  if ([TITLE_ID_REF, COVER_ID_REF].includes(currentChapterId)) {
    return 'Chapter1';
  }

  const currentChapter = chapters.find(({ spineIdRef, isChapter }) => isChapter && spineIdRef === currentChapterId);

  return currentChapter?.name;
});

export const isChapterBook = ({ bookInfo: { chapters } }) => chapters.length > 0;

export const getBookStatus = createSelector([getBookInfo], ({ status }) => status);

export const getQuestDescriptor = ({ eReader: { quest } }) => ({
  isPractice: quest.isPractice,
  chapterId: quest.lockedChapterDocument,
});
